<template>
  <ActicsLeftMenu>
    <template #app>
      <router-link class="nexa-black extra-bold p-3" :to="{ name: 'cohorts' }">S</router-link>
    </template>

    <ActicsLeftMenuActionLink :link="{ name: 'cohorts' }" icon="mdi-magnify" title="Find & Create Cohorts" />
    <ActicsLeftMenuActionLink :link="{ name: 'cohortsPinned' }" icon="mdi-pin-outline" title="Pinned Cohorts" v-if="getFlag('cohorts-show-pinned')" />
    <ActicsLeftMenuActionLink :link="{ name: 'cohortsMyCohorts' }" icon="mdi-shield-account-outline" title="My Cohorts" />
    <ActicsLeftMenuActionLink link="/Analytics/CohortAnalyticRun/Mine?actics=1" icon="mdi-flask-outline" title="Analyses" />
  </ActicsLeftMenu>
</template>

<script>
import ActicsLeftMenu from '../../layout/actics/ActicsLeftMenu.vue'
import ActicsLeftMenuActionLink from '../../layout/actics/ActicsLeftMenuActionLink.vue'
export default {
  components: { ActicsLeftMenuActionLink, ActicsLeftMenu },
}
</script>